import dynamic from 'next/dynamic';

// Client-only: uses browser APIs not compatible with SSR
const GetStarted = dynamic(() => import('marketing/get-started').then((mod) => mod.DispensaryOnboardingController), {
  ssr: false,
});

export default GetStarted;
